module.exports = __webpack_public_path__ + "static/media/Dashboard_valacta.77d38089.png";